import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { TransfersBalance } from '../components/TransfersBalance.component';
import { TransactionTypeEnum } from '../store';

class _DepositBalanceUser extends Component<IRootStoreProps> {
  componentDidMount(): void {
    this.props.store.user.transactionType = TransactionTypeEnum.DEPOSIT;
    this.props.store.user.getTransfers();
  }
  render() {
    const { user } = this.props.store;

    return (
      <TransfersBalance
        title={'Пополнение счета'}
        tableTitle={'Ваши последние пополнения:'}
        list={user.transferList}
        total={user.totalTransfers}
        limit={user.getTransfersParams.limit}
        handleTableChange={user.handleTableChange}
      />
    );
  }
}

export const DepositBalanceUserPage: WithoutStore = withStore(observer(_DepositBalanceUser));
